"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _regeneratorRuntime = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border: solid 1px ", ";\n  border-radius: ", ";\n  * {\n    overflow: visible !important;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SaveAsImage = void 0;

var antd_1 = require("antd");

var file_saver_1 = __importDefault(require("file-saver"));

var html2canvas_1 = __importDefault(require("html2canvas"));

var iconoir_react_1 = require("iconoir-react");

var react_1 = __importDefault(require("react"));

var AntIconWrapper_1 = require("./AntIconWrapper");

var Block_1 = require("./Block");

var Callout_1 = require("./Callout");

var Modal_1 = require("./Modal");

var Typography_1 = require("./Typography");

var styledTypes_1 = require("./styledTypes");

var DEFAULT_WIDTH = 800;

function SaveAsImage(_ref) {
  var _this = this;

  var children = _ref.children,
      ContentWrapper = _ref.contentWrapper,
      visible = _ref.visible,
      onCancel = _ref.onCancel,
      background = _ref.background;

  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      loading = _react_1$default$useS2[0],
      setLoading = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(DEFAULT_WIDTH),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      width = _react_1$default$useS4[0],
      setWidth = _react_1$default$useS4[1];

  var _react_1$default$useS5 = react_1.default.useState(DEFAULT_WIDTH),
      _react_1$default$useS6 = _slicedToArray(_react_1$default$useS5, 2),
      dWidth = _react_1$default$useS6[0],
      setDWidth = _react_1$default$useS6[1];

  react_1.default.useEffect(function () {
    if (visible) {
      var timeout = setTimeout(function () {
        setShowContent(false);
        setDWidth(width);
        setTimeout(function () {
          setShowContent(true);
        }, 300);
      }, 1000);
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [width]);
  var containerRef = react_1.default.useRef(null); // This is here because we need to make sure the container is ready for content
  // that checks widths before rendering.

  var _react_1$default$useS7 = react_1.default.useState(false),
      _react_1$default$useS8 = _slicedToArray(_react_1$default$useS7, 2),
      showContent = _react_1$default$useS8[0],
      setShowContent = _react_1$default$useS8[1];

  react_1.default.useEffect(function () {
    if (visible) {
      var handle = setTimeout(function () {
        setShowContent(true);
      }, 100);
      return function () {
        return clearTimeout(handle);
      };
    } else {
      setShowContent(false);
    }
  }, [visible]);
  return react_1.default.createElement(Modal_1.Modal, {
    visible: visible,
    title: 'Save as Image',
    onCancel: onCancel,
    width: 900,
    bodyStyle: {
      maxWidth: '90vw'
    },
    footer: [react_1.default.createElement(antd_1.Button, {
      key: 'cancel',
      onClick: onCancel
    }, "Cancel"), react_1.default.createElement(antd_1.Button, {
      key: 'save',
      type: 'primary',
      loading: loading,
      icon: react_1.default.createElement(AntIconWrapper_1.AntIconWrapper, {
        children: react_1.default.createElement(iconoir_react_1.SaveFloppyDisk, null)
      }),
      onClick: function onClick(e) {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var canvas;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  e.preventDefault();
                  setLoading(true);
                  _context.prev = 2;

                  if (!containerRef.current) {
                    _context.next = 10;
                    break;
                  }

                  _context.next = 6;
                  return (0, html2canvas_1.default)(containerRef.current, {
                    backgroundColor: background || null,
                    scale: 4
                  });

                case 6:
                  canvas = _context.sent;

                  if (canvas) {
                    canvas.toBlob(function (blob) {
                      if (blob) {
                        (0, file_saver_1.default)(blob, 'content.png');
                      } else {
                        antd_1.message.error('There was an error saving as an image.');
                      }

                      setLoading(false);
                    });
                  } else {
                    antd_1.message.error('There was an error saving as an image.');
                  }

                  _context.next = 11;
                  break;

                case 10:
                  antd_1.message.error('There was an error saving as an image.');

                case 11:
                  _context.next = 16;
                  break;

                case 13:
                  _context.prev = 13;
                  _context.t0 = _context["catch"](2);
                  setLoading(false);

                case 16:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 13]]);
        }));
      }
    }, "Save as Image")]
  }, react_1.default.createElement(Typography_1.BodyLarge, null, react_1.default.createElement("strong", null, "This is a preview.")), react_1.default.createElement(Typography_1.Body, {
    isBlock: true
  }, "If you are satisfied with how the content looks, click ", react_1.default.createElement("strong", null, "Save as Image"), " below."), !CSS.supports('zoom') ? react_1.default.createElement(Block_1.Block, {
    marginTop: '@size-m',
    marginBottom: '@size-s'
  }, react_1.default.createElement(Callout_1.Callout, {
    type: 'warning'
  }, react_1.default.createElement(Typography_1.Body, {
    isBlock: true
  }, react_1.default.createElement("strong", null, "Your browser might not display this preview properly.")), react_1.default.createElement(Typography_1.Body, null, "Your browser might have some trouble displaying this preview. To see the final result anyway, click ", react_1.default.createElement("strong", null, "Save as Image"), " below. For best results, use Chrome or the latest version of Microsoft Edge."))) : null, react_1.default.createElement(Block_1.Block, {
    marginBottom: '@size-m'
  }, react_1.default.createElement(Block_1.HSpaced, null, react_1.default.createElement(Typography_1.Body, null, "Scale:"), react_1.default.createElement("div", {
    style: {
      flex: 1
    }
  }, react_1.default.createElement(antd_1.Slider, {
    value: width,
    onChange: setWidth,
    min: 300,
    max: 2000
  })))), react_1.default.createElement(OuterContainer, {
    style: {
      zoom: DEFAULT_WIDTH / dWidth
    }
  }, react_1.default.createElement("div", {
    ref: containerRef,
    style: {
      padding: 30,
      width: dWidth
    }
  }, ContentWrapper ? react_1.default.createElement(ContentWrapper, {
    children: showContent ? children : null
  }) : showContent ? children : null)));
}

exports.SaveAsImage = SaveAsImage;
var OuterContainer = styledTypes_1.styled.div(_templateObject(), function (props) {
  return props.theme['@border-color-base'];
}, function (props) {
  return props.theme['@border-radius-base'];
});